export default __webpack_public_path__ + "static/media/icon-file-temp-logger.c3901352.svg";